import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { GlobalsVariablesService } from '../shared/service/global-variables.service';
import { MensagensUteis } from '../configuracoes/util/mensagens-uteis.model';
import { Util } from '../utilitarios/util';
import { Dashboard } from './dashboard.model';
import { DashboardService } from './dashboard.service';
import {CardModule} from 'primeng/card';
import { PedidoService } from '../comercial/pedido/pedido.service';
import { Setup } from '../configuracoes/setup/setup.model';
import { SetupService } from '../configuracoes/setup/setup.service';
import { Relatorio } from '../../app/shared/util/relatorio.model';
import { TipoCodigoProduto } from '../shared/constantes/tipo-codigo-produto';
import { ConfirmationService } from 'primeng/api';
import { UsuarioService } from '../seguranca/usuario/usuario.service';
import { LayoutThemeService } from '../shared/service/layout-theme.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
    usuarioPermissao;
    public dashboard = new Dashboard();    
    public ocultarMensagem: boolean = false;
    public ocultarMensagemTef: boolean = false;
    public displayAviso: boolean = false;
    public displayAvisoTef: boolean = false;
    public valorVendas: Number;
    public valorCompras: Number;
    public valorContasAPagar: Number;
    public valorContasAReceber: Number;
    public vendasAnual;
    public vendasMensal;
    public compras;
    public receberPagar;
    public financeiro;
    private lojaId;
    public message: string = '';
    public filtro: FormGroup;
    public periodo = new Array();
    public periodoFormatado = new Array();
    public pt_BR: any;
    public version: string = environment.version;
    public mensagemLicenca: String = null;
    public tenant: string;
    public dataGrafico: any;
    public dataBar: any;
    public diasRestanteLicenca;
    public duplicatasAVencer: any[] = [];
    display: boolean = false;
    public setupModel: Setup = new Setup();
    private modelRelatorio: Relatorio = new Relatorio();
    public mensagemCertificado: String = null;
    public tipoPesquisa: string;
    private id: string;

    constructor( 
        private _dashboardService: DashboardService,
        private _pedidoService: PedidoService,
        private _setupService: SetupService,
        private _usuarioService: UsuarioService,
        private fb: FormBuilder,
        public _confirmationService: ConfirmationService,
        public layoutThemeService: LayoutThemeService,
        public globalsVariablesService: GlobalsVariablesService) {
        this.tenant = (<any>window).config.tenant;    
        this.buildForm();
        this.dataBar= {
            labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
            datasets: [
                {
                    label: 'My First dataset',
                    backgroundColor: '#42A5F5',
                    borderColor: '#1E88E5',
                    data: [65, 59, 80, 81, 56, 55, 40]
                },
                {
                    label: 'My Second dataset',
                    backgroundColor: '#9CCC65',
                    borderColor: '#7CB342',
                    data: [28, 48, 40, 19, 86, 27, 90]
                }
            ]
        }


    }

    ngOnInit() {
        this.pt_BR = Util.traducaoDataCalendar();
        this.listarSetups();
        this.showLicenca();
        this.carregarDuplicatasMesAtual();
        console.log('Permissão visualizarRelatorioDuplicatasReceber:', this.globalsVariablesService.getPermissoes.visualizarRelatorioDuplicatasReceber);
      
        if(Boolean(this.globalsVariablesService.getUsuarioLogado.mostrarMensagemAvisoPosLogin)){
            this.mostrarAviso();
        }

        //PARA PREENCHIMENTO DO P-CALENDAR COM O PERÍODO
        let dataVigente = new Date();
        let dataInicio = new Date(dataVigente.getFullYear(), dataVigente.getMonth(), 1);
        this.periodo.push(dataInicio);
        let dataFim = new Date(dataVigente.getFullYear(), dataVigente.getMonth() + 1, 0);
        this.periodo.push(dataFim);
        this.filtro.get('periodo').setValue(this.periodo);

        //PARA PESQUISA DO PERÍODO
        this.periodoFormatado.push(Util.formatarData(this.periodo[0], '-'));
        this.periodoFormatado.push(Util.formatarData(this.periodo[1], '-'));
        this.valorCompras = 0.00;
        this.valorVendas = 0.00;
        this.valorContasAPagar = 0.00;
        this.valorContasAReceber = 0.00;
        this.atualizarDados();
       
        // this.reload();
    }


    private mostrarAviso(): void{
      //  this.displayAviso = true;
        this.displayAvisoTef = true;
    }

    public onClickAviso(){
        //this.displayAviso = false;
        this.displayAvisoTef = false;
        /*if(this.ocultarMensagem)
            this._usuarioService.ocultarMensagemAvisoDashboard(Number(this.globalsVariablesService.usuarioLogado.id));*/

            if(this.ocultarMensagemTef)
            this._usuarioService.ocultarMensagemAvisoDashboard(Number(this.globalsVariablesService.usuarioLogado.id));

        

        
    }

    buildForm(): void {
        this.filtro = this.fb.group({
            'periodo': [''],
            'tenant': [this.tenant]
            
        });
    }
    showLicenca() {
        if(this.globalsVariablesService.getMensagensUteis.descricao != null){
            this.mensagemLicenca = this.globalsVariablesService.getMensagensUteis.descricao;
            this.display = true;
        }else{
            this.display = false;
        }
       
    }

    carregarDuplicatasMesAtual() {
        this._dashboardService.duplicatasMesAtual()
            .then(data => {
                console.log("Duplicatas recebidas:", data);
                this.duplicatasAVencer = data;
            })
            .catch(err => {
                console.error("Erro ao carregar duplicatas do mês:", err);
            });
    }

    onSelectDate() {
        this.periodo = new Array();
        this.periodoFormatado = new Array();
        this.periodo = this.filtro.get('periodo').value;

        if (this.periodo[1] != null) {
            //SE SELECIONADO AS 2 DATAS
            this.periodoFormatado.push(Util.formatarData(this.periodo[0], '-'));
            this.periodoFormatado.push(Util.formatarData(this.periodo[1], '-'));
            console.log("Selecionado as 2 Datas: \n", this.periodoFormatado);
            this.atualizarDados();
        }
    }

    atualizarDados() {
        var interval = setInterval(() => {
            this.lojaId = this.globalsVariablesService.getUsuarioLogado.lojaId;
            if (this.lojaId != null) {
                clearInterval(interval);
                // Foi recuperado totalmente as permissões
                this._dashboardService.totalVendasRealizadas(this.lojaId, this.periodoFormatado).then(res => {
                    this.dashboard = res;
                    this.valorVendas = this.dashboard.valorVendas;
                    this.valorCompras = this.dashboard.valorCompras;
                    this.valorContasAPagar = this.dashboard.valorDuplicatasPagar;
                    this.valorContasAReceber = this.dashboard.valorDuplicatasReceber;
                    /*
                      this.valorVendas = 0.00;
                      this.valorCompras = 0.00;
                      this.valorContasAPagar = 0.00;
                      this.valorContasAReceber = 0.00;
                    */
                   
                    this.diasRestanteLicenca = this._dashboardService.findDiasRestantesLicenca(this.lojaId);

                    this.atualizarGraficos();
                });
                
                //console.log(this.diasRestanteLicenca)
            }
        }, 600);
    }

    atualizarGraficos() {
        this.vendasMensal = {
            labels: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            datasets: [
                {
                    label: 'Ano Anterior',
                    data: [65, 69, 80, 81, 50, 45, 30, 35, 33, 38, 43, 44],
                    borderColor: '#4bc0c0',
                    backgroundColor: '#4bd2d29c',
                    fill: 'start'
                },
                {
                    label: 'Ano Atual',
                    data: [28, 26, 20, 19, 40, 49, 50, 55, 62, 67, 60, 58],
                    borderColor: '#565656',
                    backgroundColor: '#90909094',
                    fill: 'start'
                }
            ]
        }

        this.vendasAnual = {
            labels: ['Ano Anterior', 'Ano Atual'],
            datasets: [
                {
                    label: 'Vendas',
                    data: [10265, 1039],
                    backgroundColor: '#4bc0c0'
                }
            ]
        }

        this.compras = {
            labels: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            datasets: [
                {
                    label: 'Ano Anterior',
                    data: [65, 69, 80, 81, 50, 45, 30, 35, 33, 38, 43, 44],
                    fill: 'start',
                    borderColor: '#f1f1f1',
                    fontColor: '#f1f1f1'
                },
                {
                    label: 'Ano Atual',
                    data: [75, 89, 83, 81, 52, 35, 33, 91, 96, 61, 56, 61],
                    fill: 'start',
                    borderColor: '#676767',
                    fontColor: '#f1f1f1'
                }
            ]
        }

        this.receberPagar = {
            labels: ['Pagar', 'Receber'],
            datasets: [
                {
                    data: [this.valorContasAPagar, this.valorContasAReceber],
                    backgroundColor: [
                        "#FF6384",
                        "#30ce85"
                    ],
                    hoverBackgroundColor: [
                        "#FF6384",
                        "#30ce85"
                    ]
                }
            ]
        }

        this.financeiro = {
            labels: ['1 ao 5', '6 ao 10', '11 ao 15', '16 ao 20', '21 ao 25', '26 ao 31'],
            datasets: [
                {
                    label: 'Entrada',
                    data: [845, 549, 780, 451, 1454, 889],
                    backgroundColor: '#30ce85'
                },
                {
                    label: 'Saída',
                    data: [-145, -180, -254, -122, -211, -440],
                    backgroundColor: '#FF6384'
                }
            ]
        }

        this.dataGrafico = {
            labels: ['Vendas','A Receber','A Pagar', 'Compras'],
            datasets: [
                {
                    data: [this.valorVendas, this.valorContasAReceber, this.valorContasAPagar, this.valorCompras ],
                    backgroundColor: [
                        "#FFCE56",
                        '#1ade84',
                        "#FF6384",
                        "#36A2EB",
                       
                    ],
                    hoverBackgroundColor: [
                        "#F1FE56",
                        '#1aF616',
                        "#FF638422",
                        "#36F2EB",
                      
                 
                    ]
                }]    
            };
    }


    reload(): void {
        let acesso = localStorage.getItem("primeiroAcesso");
        if (acesso == 'true') {
            window.location.reload();
            localStorage.removeItem("primeiroAcesso")
        }
        else {
            return;
        }
    }

    consultarCertificado() {

        this._pedidoService.verificarCertificado(Number(this.setupModel.lojaPrecoId)).then(data => {
            this.modelRelatorio = data;

        }).then(
            success => {
                this.showValidadeCertificado(this.modelRelatorio);
            });

      
    }

    showValidadeCertificado(modelRelatorio: any) {
        if(this.modelRelatorio){
            if(this.modelRelatorio.nome != null){
                this.mensagemCertificado = "Seu certificado digital vence em" + " " + this.modelRelatorio.nome  + " " +"dia(s)"
                this.display = true;
            }else{
                this.display = false;
            }
        }
    }

    public listarSetups() {
        this._setupService.getSetup().then(res => {
            this.carregarInformacoesSetup(res);
            //this.consultarCertificado();
        });
    }

    public carregarInformacoesSetup(res) {
        this.setupModel = res;
        if (this.setupModel.vendaTipoCodigoProduto == TipoCodigoProduto.CODIGO) {
            this.tipoPesquisa = 'codigo';
        } else {
            this.tipoPesquisa = 'outroCodigo';
        }
        this.consultarCertificado();
        //if (this.id == 'NaN') {
           // this.carregarInfosPadrao();
        //}
    }

}

